'use client';

import { useGsapContext } from 'hooks/animation/useGsapContext';
import { CustomImage as Image } from 'components/shared';
import gsap from 'gsap';
import { useRef } from 'react';
import { useIsomorphicLayoutEffect } from 'hooks/dom/useIsomorphicLayoutEffect';
import { H3, P } from './StyleComponents';
import styles from './NudgeCard.module.css';

export const NudgeCard = ({
  className,
  title,
  description,
  img,
}: {
  className?: string;
  title: string;
  description: string;
  img: string;
}) => {
  const container = useRef<HTMLDivElement>(null);
  const gsapContext = useGsapContext();

  const animationInit = () => {
    if (!container.current) return;

    gsapContext.add(() => {
      const tl = gsap.timeline({
        defaults: {
          duration: 1,
        },
        scrollTrigger: {
          trigger: container.current,
          scrub: 0.5,
          start: 'top 60%',
          end: 'bottom 30%',
        },
      });

      tl.fromTo(
        '.translateup',
        {
          yPercent: 0,
        },
        {
          yPercent: -40,
        },
      );

      tl.pause();
    });
  };

  useIsomorphicLayoutEffect(() => {
    const animTimer = setTimeout(animationInit, 100);

    return () => {
      if (animTimer) clearTimeout(animTimer);
    };
  }, []);

  return (
    <div
      className={`${styles.root}${className ? ` ${className}` : ''} container`}
      ref={container}
    >
      <div className={styles.text}>
        <H3 align="left">{title ?? 'The only nudges that you need'}</H3>
        <P color="rgba(255, 255, 255, 0.5)" align="left">
          {description ??
            'Personalised nudges for a healthier you. Get tailor-made insights and alerts to help you make better choices in real time.'}
        </P>
      </div>
      <div className={styles.image}>
        <Image
          className="translateup"
          src={img ?? 'web_v2/illustrations/nudges-trail.png'}
          alt="nudges"
          fill
        />
      </div>
    </div>
  );
};
